
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import BaseUpload from './BaseUpload.vue'
// @ts-ignore
import CircleProgress from 'vue-circleprogressbar'
// @ts-ignore
import { creatMaterialFileSymlink } from '@/api/placeOrder'
import { handleUrl } from '../../helper'
import FileItem from './FileItem.vue'
import { IFileList, IOrderForm } from '@/types/placeOrderTypes'
import { IServiceMap } from '@/business/BusinessFormData'
import { Action } from 'vuex-class'
import { FileTypes, getOriginFilesName, hasRar7z, sizeFilter, UploadService } from './fileOperations'

@Component({
  components: {
    BaseUpload,
    CircleProgress,
    FileItem,
  },
})
export default class ZipUpload extends Vue {
  @Action('setOrderId') setOrderId: any

  @Prop({ default: false }) uploading!: boolean
  @Prop({ default: false }) checking!: boolean
  @Prop({ default: () => [] }) zipList!: any[]
  @Prop({ required: true }) order_id!: string
  @Prop({}) formInfo!: IServiceMap
  @Prop() form!: IOrderForm
  @Prop() activeNames!: string[]
  @Prop() files!: IFileList[]
  @Prop() checkForm!: Function
  @Prop() screenForm!: Function
  @Prop() selectFileType!: number

  acceptMap = {
    'default': '.zip',
    'ppt2seewo': '.zip, .rar, .7z',
  }

  get isPpt2Seewo() {
    return this.formInfo.formData.service_content === 25
  }

  get title() {
    return this.formInfo.category === 'pptUpload' ? 'PPT文件压缩包' : '方正项目压缩包（zip格式）'
  }

  @Emit('update:zipList')
  updateZipList(list: any[]) {
    return list
  }

  @Emit('upload-start')
  setUploading(value: boolean) {
    return value
  }

  sizeFilter(size: number) {
    return sizeFilter(size)
  }

  getOriginFilesName(name: string) {
    return getOriginFilesName(name)
  }

  async handleFileSelected(files: any[]) {
    if (files.length) {
      this.updateZipList([...this.zipList, ...files])
    }
  }

  selectMore() {
    ;(this.$refs.baseUpload as any).selectFile()
  }

  async startUpload() {
    await UploadService.uploadFiles({
      context: this,
      fileList: this.zipList,
      fileType: FileTypes.ZIP,
      screenForm: this.screenForm,
      checkForm: this.checkForm,
      isPpt2Seewo: this.isPpt2Seewo,
      // 自定义过滤条件
      filterCondition: (item, form: IOrderForm) => {
        if (this.isPpt2Seewo) {
          return (
            item.zip &&
            !form.material.oss_zip_files.filter((zip: any) => zip!.name === item.zip!.name).length &&
            !item.ZIPinZIPList?.length
          )
        } else {
          return item.zip && !form.material.oss_fbd_zips.filter(zip => zip!.name === item.zip!.name).length
        }
      },
      // 处理已存在的文件
      handleExistingFile: async (item, path, form) => {
        const symlinkData = await creatMaterialFileSymlink({
          ticket_id: this.order_id,
          origin_path: path,
          name: item.zip!.name,
          path_alias: 'content_zip_type',
        })

        if (this.isPpt2Seewo) {
          if (!form.material.oss_zip_files) form.material.oss_zip_files = []

          if (hasRar7z(item.zip!.name)?.length) {
            form.material.oss_zip_files.push({
              path: handleUrl(symlinkData.symlink_path),
              is_del: false,
              extension: hasRar7z(item.zip!.name) as string,
              name: item.zip!.name,
              md5: item.md5,
            })
          } else {
            form.material.oss_zip_files.push({
              path: handleUrl(symlinkData.symlink_path),
              is_del: false,
              extension: 'zip',
              name: item.zip!.name,
              md5: item.md5,
            })
          }
        } else {
          if (!form.material.oss_fbd_zips) form.material.oss_fbd_zips = []

          form.material.oss_fbd_zips.push({
            path: handleUrl(symlinkData.symlink_path),
            is_del: false,
            extension: 'zip',
            name: item.zip!.name,
            fbd_info: item.fbdList,
            md5: item.md5,
          })
        }
      },
      afterUpload: (item, symlinkData, form) => {
        if (this.form) {
          if (this.isPpt2Seewo) {
            if (!form.material.oss_zip_files) form.material.oss_zip_files = []
            form.material.oss_zip_files.push({
              path: handleUrl(symlinkData.symlink_path),
              is_del: false,
              extension: 'zip',
              name: item.zip!.name,
              md5: item.md5,
            })
          } else {
            if (!form.material.oss_fbd_zips) form.material.oss_fbd_zips = []
            form.material.oss_fbd_zips.push({
              path: handleUrl(symlinkData.symlink_path),
              is_del: false,
              extension: 'zip',
              name: item.zip!.name,
              fbd_info: item.fbdList,
              md5: item.md5,
            })
          }
        }
      },
    })
  }

  removeZipFile(name: string) {
    const zipIndex = this.files.findIndex(item => item.zip && item.zip.name === name)
    const ListIndex = this.zipList.findIndex(item => item.zip && item.zip.name === name)
    this.files.splice(zipIndex, 1)
    this.zipList.splice(ListIndex, 1)

    if (this.form.material.oss_fbd_zips.filter(item => item.name === name).length) {
      this.form.material.oss_fbd_zips.splice(ListIndex, 1)
    }
  }

  downloadZip(name: string) {
    if (this.form && this.form.material && this.form.material.oss_fbd_zips) {
      const zip = this.form.material.oss_fbd_zips.find(item => item.name === name)
      const a = document.createElement('a')
      let path = ''
      if (zip!.path?.includes('+')) {
        path = zip!.path!.replaceAll('+', '%2B')
      } else {
        path = zip!.path!
      }
      a.href = `https://hexin-worksheet.oss-cn-shanghai.aliyuncs.com/${path}`
      a.click()
    }
  }
}
